import React, { useCallback, useEffect } from 'react';
import { C_PAC } from '@lba-dev/package.local-globals/comboType';
import {
  descHabitatData
} from '@lba-dev/package.local-globals/atlanticQuestion';
import Grid from '@mui/material/Grid';

import CustomTextField from '../../CustomInputs/CustomTextField';
import { withMediaQuery } from '../../../hoc';
const paths = {
  comboName: ['combination', 'name'],
  comboModel: ['combination', 'model'],
  comboPower: ['combination', 'power'],
  comboFjs: ['combination', 'fjs'],
  comboClassR: ['combination', 'classRegul'],
  temperature: ['combination', 'temperature'],
  comboType: ['combination', 'comboType'],
  thermoBrand: ['combination', 'thermostat', 'brand'],
  thermoModel: ['combination', 'thermostat', 'model'],
};
const [option1, option2] = descHabitatData.question.at(0).options;

const InfoCombo = ({ merge, setData, isUp }) => {
  const getDefaultValueTemp = useCallback(() => {
    if (merge.getIn(paths.comboType) !== C_PAC) {
      return '';
    }
    const answer = merge.getIn([
      'metiersDevis',
      'answers',
      descHabitatData.question.at(0).label
    ]);

    switch (answer) {
      case option1:
        return 'MOYENNE';
      case option2:
        return 'BASSE';
      default:
        return '';
    }
  }, [merge]);

  const getDefaultFjs = useCallback(() => {
    if (merge.getIn(paths.comboType) !== C_PAC) {
      return undefined;
    }

    const answer = merge.getIn([
      'metiersDevis',
      'answers',
      descHabitatData.question.at(0).label
    ]);

    const products = merge.getIn(['products', 'list'])?.toJS() || [];
    const productWithEtas = products
      .find((product) => product.etas);

    if (!productWithEtas || typeof productWithEtas.etas !== 'string') {
      return undefined;
    }

    const parts = productWithEtas.etas
      .split('/')
      .map(p => p.trim())
      .filter(Boolean);

    if (parts.length === 0) {
      return undefined;
    }

    let value;
    switch (answer) {
      case option1:
        value = parts.length === 2 ? parts[1] : parts[0];
        break;
      case option2:
        value = parts[0];
        break;
      default:
        return undefined;
    }

    const parsed = Number.parseFloat(value);
    return Number.isNaN(parsed) ? undefined : parsed;
  }, [merge]);

  useEffect(() => {
    if (merge.getIn(paths.comboType) === C_PAC) {
      setData(paths.comboClassR, 'Classe IV');
    }
    if (!merge.getIn(paths.temperature)) {
      setData(paths.temperature, getDefaultValueTemp());
    }
    const fjs = getDefaultFjs();
    if (fjs) {
      setData(paths.comboFjs, fjs);
    }
  }, [merge, getDefaultFjs, getDefaultValueTemp, setData]);

  return <>
    <CustomTextField
      label='Nom chaudière'
      path={paths.comboName}
      value={merge.getIn(paths.comboName)}
      setData={setData}
      grid
      xs={12}
      sm={6}
    />
    <CustomTextField
      label='Model chaudière'
      texttransform='none'
      path={paths.comboModel}
      value={merge.getIn(paths.comboModel)}
      setData={setData}
      grid
      xs={12}
      sm={6}
    />
    <CustomTextField
      label='Classe de régulation'
      texttransform='none'
      path={paths.comboClassR}
      value={merge.getIn(paths.comboClassR)}
      setData={setData}
      grid
      xs={12}
      sm={6}
    />
    <CustomTextField
      label='Puissance chaudière'
      texttransform='none'
      path={paths.comboPower}
      value={merge.getIn(paths.comboPower)}
      setData={setData}
      grid
      xs={12}
      sm={6}
      multiline={false}
      placeholder="Puissance kW..."
      fullWidth
      type="number"
    />
    <CustomTextField
      label='Etas fjs'
      texttransform='none'
      path={paths.comboFjs}
      value={merge.getIn(paths.comboFjs)}
      setData={setData}
      grid
      xs={12}
      sm={6}
      key={6}
      multiline={false}
      placeholder="Etas fjs..."
      fullWidth
      type="number"
    />
    {merge.getIn(paths.comboType) === C_PAC ? <CustomTextField
      label='Température'
      texttransform='none'
      path={paths.temperature}
      value={merge.getIn(paths.temperature)}
      setData={setData}
      grid
      xs={12}
      sm={6}
      multiline={false}
    /> :
      isUp.xs &&
      <Grid item sm={6} children='&nbsp;' />
    }
    <CustomTextField
      label='Marque du thermostat'
      texttransform='none'
      path={paths.thermoBrand}
      value={merge.getIn(paths.thermoBrand)}
      setData={setData}
      grid
      xs={12}
      sm={6}
      multiline={false}
    />
    <CustomTextField
      label='Modele thermostat'
      texttransform='none'
      path={paths.thermoModel}
      value={merge.getIn(paths.thermoModel)}
      setData={setData}
      grid
      xs={12}
      sm={6}
      multiline={false}
    />
  </>;
};

export default withMediaQuery()(InfoCombo);
